// import { useEffect, useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import api from '../api';

// const EmployeeList = () => {
//   const [employees, setEmployees] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const load = async () => {
//     setLoading(true);
//     try {
//       const res = await api.get('/employees');
//       setEmployees(res.data);
//     } catch (err) {
//       console.error(err);
//       alert('Error loading employees');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     load();
//   }, []);

//   const handleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this employee?')) return;
//     try {
//       await api.delete(`/employees/${id}`);
//       load();
//     } catch (err) {
//       console.error(err);
//       alert('Error deleting employee');
//     }
//   };

//   return (
//     <div className="card">
//       <div className="card-header">
//         <h2>Employees</h2>
//         <button className="btn btn-primary" onClick={() => navigate('/employees/new')}>
//           + Add Employee
//         </button>
//       </div>

//       {loading ? (
//         <p>Loading...</p>
//       ) : employees.length === 0 ? (
//         <p className="text-muted">No employees yet. Click "Add Employee".</p>
//       ) : (
//         <table className="table">
//           <thead>
//             <tr>
//               <th>Emp Code</th>
//               <th>Name</th>
//               <th>Email</th>
//               <th>Designation</th>
//               <th>Department</th>
//               <th>Gross Pay</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {employees.map((e) => (
//               <tr key={e.id}>
//                 <td>{e.emp_code}</td>
//                 <td>{e.first_name} {e.last_name}</td>
//                 <td>{e.email}</td>
//                 <td>{e.designation}</td>
//                 <td>{e.department}</td>
//                 <td>{Number(e.basic_monthly) + 
//                       Number(e.hra_monthly) + 
//                       Number(e.special_allowance_monthly) + 
//                       Number(e.lta_monthly)}</td>
//                 <td>
//                   <Link className="btn btn-secondary" to={`/employees/${e.id}/edit`}>
//                     Edit
//                   </Link>{' '}
//                   <button
//                     className="btn btn-danger"
//                     onClick={() => handleDelete(e.id)}
//                   >
//                     Delete
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// };

// export default EmployeeList;













import { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../api";

const EmployeeList = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [statusView, setStatusView] = useState("active"); // active | resigned | transfer
  const [counts, setCounts] = useState({ active_count: 0, resigned_count: 0 });
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [managers, setManagers] = useState([]);
  const [transferForm, setTransferForm] = useState({
    from_manager_id: "",
    to_manager_id: "",
  });
  const navigate = useNavigate();

  const load = async (view = statusView) => {
    setLoading(true);
    try {
      const res = await api.get("/employees", { params: { status: view } });
      setEmployees(res.data);
    } catch (err) {
      console.error(err);
      alert("Error loading employees");
    } finally {
      setLoading(false);
    }
  };

  const loadCounts = async () => {
    try {
      const res = await api.get("/employees/counts");
      setCounts(res.data || { active_count: 0, resigned_count: 0 });
    } catch (err) {
      console.error("Error loading counts", err);
    }
  };

  useEffect(() => {
    load(statusView);
    loadCounts();
    if (statusView === "transfer") {
      loadManagers();
    }
    setPage(1);
  }, [statusView]);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete (mark resigned) this employee?")) return;
    const resigned_date = window.prompt("Enter resignation date (YYYY-MM-DD)", new Date().toISOString().slice(0, 10));
    if (!resigned_date) return;
    try {
      await api.delete(`/employees/${id}`, { data: { resigned_date } });
      await load(statusView);
      await loadCounts();
    } catch (err) {
      console.error(err);
      alert("Error deleting employee");
    }
  };

  const loadManagers = async () => {
    try {
      const res = await api.get("/employees/managers");
      setManagers(res.data || []);
    } catch (err) {
      console.error("Error loading managers", err);
    }
  };

  const handleTransfer = async (e) => {
    e.preventDefault();
    if (!transferForm.from_manager_id || !transferForm.to_manager_id) {
      alert("Select both managers");
      return;
    }
    if (transferForm.from_manager_id === transferForm.to_manager_id) {
      alert("Managers must be different");
      return;
    }
    try {
      await api.post("/employees/transfer-reports", transferForm);
      alert("Reportees transferred");
      setTransferForm({ from_manager_id: "", to_manager_id: "" });
      await load("active");
    } catch (err) {
      console.error("Transfer error", err);
      alert("Error transferring reportees");
    }
  };

  const filteredEmployees = useMemo(() => {
    if (!search.trim()) return employees;
    const q = search.toLowerCase();
    return employees.filter((e) =>
      [
        e.emp_code,
        e.first_name,
        e.last_name,
        e.email,
        e.designation,
        e.department,
      ]
        .filter(Boolean)
        .some((v) => v.toLowerCase().includes(q))
    );
  }, [employees, search]);

  useEffect(() => {
    setPage(1);
  }, [search, statusView]);

  const totalPages = Math.max(
    1,
    Math.ceil((filteredEmployees?.length || 0) / pageSize)
  );
  const paginated = filteredEmployees.slice(
    (page - 1) * pageSize,
    page * pageSize
  );

  const formatGross = (e) => {
    const gross =
      Number(e.basic_monthly || 0) +
      Number(e.hra_monthly || 0) +
      Number(e.special_allowance_monthly || 0) +
      Number(e.lta_monthly || 0);

    return `₹${gross.toLocaleString("en-IN")}`;
  };

  const managerNameById = useMemo(() => {
    const map = new Map();
    employees.forEach((e) => {
      map.set(e.id, `${e.first_name || ""} ${e.last_name || ""}`.trim());
      if (e.manager_id && e.manager_name) {
        map.set(`mgr-${e.manager_id}`, e.manager_name.trim());
      }
    });
    return map;
  }, [employees]);

  return (
    <div className="employees-shell">
      {/* Header */}
      <div className="employees-header">
        <div>
          <h1 className="employees-title">Employees</h1>
          <p className="employees-subtitle">
            Manage employee master details and salary structure.
          </p>
        </div>

        <div className="employees-header-right">
          <div className="employees-toggle">
            <button
              className={`chip-toggle ${
                statusView === "active" ? "chip-active" : ""
              }`}
              onClick={() => setStatusView("active")}
            >
              Active ({counts.active_count || 0})
            </button>
            <button
              className={`chip-toggle ${
                statusView === "resigned" ? "chip-active" : ""
              }`}
              onClick={() => setStatusView("resigned")}
            >
              Resigned ({counts.resigned_count || 0})
            </button>
            <button
              className={`chip-toggle ${
                statusView === "transfer" ? "chip-active" : ""
              }`}
              onClick={() => setStatusView("transfer")}
            >
              Transfer Reportees
            </button>
          </div>
          <button
            className="btn-primary-large"
            onClick={() => navigate("/employees/new")}
          >
            + Add Employee
          </button>
        </div>
      </div>

      {/* Toolbar */}
      {statusView !== "transfer" && (
        <div className="employees-toolbar">
          <input
            type="text"
            placeholder="Search by name, code, email, department..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="employees-search-input"
          />
        </div>
      )}

      {statusView === "transfer" && (
        <div className="employees-table-card">
          <h3 style={{ marginTop: 0 }}>Transfer Reportees</h3>
          <p className="text-muted" style={{ marginTop: 4 }}>
            Move all active reportees from one manager to another.
          </p>
          <form
            className="filter-row"
            onSubmit={handleTransfer}
            style={{ marginTop: 10 }}
          >
            <div>
              <label className="filter-label">From Manager</label>
              <select
                className="filter-input"
                value={transferForm.from_manager_id}
                onChange={(e) =>
                  setTransferForm((f) => ({
                    ...f,
                    from_manager_id: e.target.value,
                  }))
                }
              >
                <option value="">Select</option>
                {managers.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.emp_code} - {m.first_name} {m.last_name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="filter-label">To Manager</label>
              <select
                className="filter-input"
                value={transferForm.to_manager_id}
                onChange={(e) =>
                  setTransferForm((f) => ({
                    ...f,
                    to_manager_id: e.target.value,
                  }))
                }
              >
                <option value="">Select</option>
                {managers.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.emp_code} - {m.first_name} {m.last_name}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ alignSelf: "flex-end" }}>
              <button className="btn btn-primary" type="submit">
                Transfer
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Table / content */}
      <div className="employees-table-card">
        {loading ? (
          <div className="employees-loading">Loading employees…</div>
        ) : filteredEmployees.length === 0 ? (
          <div className="employees-empty">
            <p>No employees found.</p>
            { statusView !== "resigned" &&
              <button
                className="btn-secondary"
                onClick={() => navigate("/employees/new")}
              >
                + Add your first employee
              </button>
            }
          </div>
        ) : (
          <div className="employees-table-wrapper">
            <table className="employees-table">
              <thead>
                <tr>
                  <th>Emp Code</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Designation</th>
                  <th>Department</th>
                  <th>Manager?</th>
                  <th>Reports To</th>
                  {statusView === "resigned" && <th>Resigned Date</th>}
                  <th>Gross Pay</th>
                  <th style={{ width: 140 }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {paginated.map((e) => (
                  <tr key={e.id}>
                    <td className="emp-code-cell">{e.emp_code}</td>
                    <td>
                      <div className="emp-name-cell">
                        <span className="emp-name">
                          {e.first_name} {e.last_name}
                        </span>
                      </div>
                    </td>
                    <td className="emp-email">{e.email}</td>
                    <td>{e.designation || "-"}</td>
                    <td>
                      {e.department ? (
                        <span className="badge-dept">{e.department}</span>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>
                      {e.is_manager ? (
                        <span className="badge badge-success">Yes</span>
                      ) : (
                        <span className="badge badge-muted">No</span>
                      )}
                    </td>
                    <td>
                      {e.manager_id
                        ? e.manager_name ||
                          managerNameById.get(`mgr-${e.manager_id}`) ||
                          managerNameById.get(e.manager_id) ||
                          `ID ${e.manager_id}`
                        : "—"}
                    </td>
                    {statusView === "resigned" && (
                      <td>{e.updated_at ? String(e.updated_at).slice(0, 10) : "-"}</td>
                    )}
                    <td>{formatGross(e)}</td>
                    <td>
                      {statusView === "resigned" ? (
                        <span className="text-muted-small">Resigned</span>
                      ) : (
                        <div className="actions-cell">
                          <Link
                            className="btn-chip"
                            to={`/employees/${e.id}/edit`}
                          >
                            Edit
                          </Link>
                          <button
                            className="btn-chip btn-chip-danger"
                            onClick={() => handleDelete(e.id)}
                          >
                            Delete
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="pagination-row">
              <button
                className="btn-secondary"
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                disabled={page === 1}
              >
                Prev
              </button>
              <span className="pagination-text">
                Page {page} of {totalPages}
              </span>
              <button
                className="btn-secondary"
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                disabled={page === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployeeList;
